<self-filer-section
  [header]="'INFO.PM.DEBIT'"
  [description]="
    ('ON_BOARDING.ACH_DEBIT_DESC' | translate) + (hasFilerCode ? '' : '<br/>' + ('ON_BOARDING.ACH_METHOD_CARD.UPDATE_MESSAGE' | translate))
  "
>
  <card-default [description]="'COMPANY.ACH_DEBIT_SECTION_DESCRIPTION'" [sticky]="true">
    <div class="form-description mb-3" [innerHTML]="'ON_BOARDING.ACH_DEBIT_PUN_TEXT_2' | translate : { link: ACH_FORM_400_LINK }"></div>
    <button card-footer type="button" class="btn btn-primary" (click)="goToForm()" [disabled]="!hasFilerCode">
      {{ "ON_BOARDING.GO_TO_FORM_400" | translate }}
    </button>
  </card-default>
  <card-default [description]="!isSuccess ? 'ON_BOARDING.ACH_DEBIT_PUN_TEXT_3' : ''" [sticky]="false">
    <!--    <div header-action *ngIf="isSuccess && !isOpenForm" class="d-flex justify-content-end">-->
    <!--      <i class="fa fa-pencil edit-toggle" (click)="openForm()"></i>-->
    <!--    </div>-->
    <div header-action class="d-flex justify-content-end">
      <dropdown-action *ngIf="isSuccess" [iconColor]="iconColor" [menuMode]="menuMode" [id]="'abi-profile-actions'" className="m-1">
        <button dropdown-item *ngIf="!isOpenForm" class="dropdown-item" (click)="openForm()">
          {{ "BUTTON.EDIT" | translate }}
        </button>
        <button dropdown-item class="dropdown-item" (click)="clearAndSave()">
          {{ "BUTTON.DELETE" | translate }}
        </button>
      </dropdown-action>
    </div>

    <div *ngIf="isSuccess && !isOpenForm">
      <self-filer-field-view [label]="'LABELS.PAYER_UNIT_NUMBER'">{{ achMethodDetails.paymentUnitNumber }}</self-filer-field-view>
    </div>
    <div *ngIf="isOpenForm">
      <div class="form-row">
        <div class="col-12">
          <app-control-wrapper [control]="formGroup.get('paymentUnitNumber')" [helper]="'FORM_HELPER.PAYER_UNIT_NUMBER'" [errors]="errors">
            <label control-label for="pun">{{ "LABELS.PAYER_UNIT_NUMBER" | translate }}</label>
            <input
              control-wrapper
              type="text"
              [formControl]="formGroup.get('paymentUnitNumber')"
              class="form-control"
              id="pun"
              name="pun"
              [dropSpecialCharacters]="false"
              [mask]="'0{6}'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
              [maxMaskLength]="6"
            />
          </app-control-wrapper>
        </div>
        <div class="col-12 form-description mb-2">
          {{ "COMPANY.AUTHORIZATION_AGREEMENT_ACCEPTED" | translate }}
        </div>
        <div class="col-12 mb-2" id="control-authorizationAgreementAccepted">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="authorizationAgreementAccepted"
                [formControl]="formGroup.get('authorizationAgreementAccepted')"
              />
              <label class="custom-control-label" for="authorizationAgreementAccepted">
                {{ "FORM_LABEL.I_AGREE_WITH_TEXT_ABOVE" | translate }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-section" id="payerUnitNumberApproval-section">
          <div class="container">
            <div class="form-row form-row-header-section">
              <div class="col-12">
                <div class="form-section-title">{{ "COMPANY.ACH_ACCOUNT_APPROVAL" | translate }}</div>
              </div>
              <div class="col-12">
                <div class="form-section-description">
                  <span>{{ "COMPANY.ACH_ACCOUNT_APPROVAL_HINT.START" | translate }}</span>

                  <a href="#" (click)="openPUNExampleModal($event)">{{ "BUTTON.HERE" | translate }}</a>

                  <span>{{ "COMPANY.ACH_ACCOUNT_APPROVAL_HINT.END" | translate }}</span>
                </div>
              </div>
              <div class="col-12 pt-3 pb-3">
                <document-upload-desktop
                  [id]="'company-pun-upload-form'"
                  [uploadedDocument]="punDocument"
                  [attachmentName]="'DOCUMENT_TYPE.ACH_APPROVAL'"
                  [isLoading]="isLoadingCompanyPun"
                  [isStretched]="true"
                  [isRequired]="true"
                  [canUploadDocuments]="true"
                  [canRemoveDocuments]="true"
                  (upload)="uploadDocument($event)"
                  (remove)="deleteDocument($event)"
                  (stateUpdate)="updateDocumentState(punDocument.id, $event)"
                ></document-upload-desktop>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      card-footer
      *ngIf="!isSuccess && !isOpenForm"
      type="button"
      class="btn btn-primary"
      (click)="openForm()"
      [disabled]="!hasFilerCode"
    >
      {{ "ON_BOARDING.I_HAVE_PUN" | translate }}
    </button>
    <button
      card-footer
      *ngIf="isOpenForm"
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="formGroup.invalid || !punDocument"
    >
      {{ "BUTTON.SAVE" | translate }}
    </button>
    <button card-footer *ngIf="isOpenForm" type="button" class="btn btn-secondary" (click)="isOpenForm = false">
      {{ "BUTTON.CANCEL" | translate }}
    </button>
  </card-default>
</self-filer-section>

<custom-modal size="lg" [header]="'COMPANY.PUN_MODAL.HEADER'" [(open)]="showPUNExampleModal">
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_DATE' | translate"></p>
  <p>
    <span [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_1' | translate"></span>
    <b class="hint-text" [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_2' | translate"></b>
    <span [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_3' | translate"></span>
  </p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_BROKERS_AND_SELF_FILERS' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_IMPORTERS' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ATTACHED' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ANY_QUESTIONS' | translate"></p>
</custom-modal>
